import { render, staticRenderFns } from "./LiveEditorDialog.vue?vue&type=template&id=bfa80312&scoped=true"
import script from "./LiveEditorDialog.vue?vue&type=script&lang=js"
export * from "./LiveEditorDialog.vue?vue&type=script&lang=js"
import style0 from "./LiveEditorDialog.vue?vue&type=style&index=0&id=bfa80312&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa80312",
  null
  
)

export default component.exports